import { useLocation, useNavigate, useParams } from 'react-router';
import { FormProvider, useForm } from 'react-hook-form';

import { PrevHeaderBarWithTitleTemplate } from '#templates';

import ReactQuillEditor from 'src/refactor_shared/ui/react-quill-editor';
import CommunityWriteForms from 'src/refactor_components/community/write/community-write-forms';
import useThreadMutations, {
  TrainerCommunityWriteProps
} from '../useThreadMutations';
import { useQueryClient } from '@tanstack/react-query';
import { useUserInfo } from '#providers/UserInfo';
import { useToast } from '#providers/ToastProvider';
import { isUser } from 'src/refactor_shared/util/isUser';

type InformationCommunityWriteProps = {
  category: string;
  title: string;
  content: string;
  imageUrl: string;
};

const InformationCommunityWrite = () => {
  const params = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { isLogIn } = useUserInfo();
  const { showToast } = useToast();

  const methods = useForm<InformationCommunityWriteProps>({
    defaultValues: state ? state : { category: '', title: '', content: '' }
  });

  const { threadMutate } = useThreadMutations({
    id: params.id
  });

  const onSubmit = (data: TrainerCommunityWriteProps) => {
    if (!data.category) {
      showToast({ type: 'fail', message: '카테고리를 선택해주세요' });
      return;
    }
    if (!data.title) {
      showToast({ type: 'fail', message: '제목을 입력해주세요' });
      return;
    }
    if (!data.content || data.content === '<p><br></p>') {
      showToast({ type: 'fail', message: '내용을 입력해주세요' });
      return;
    }

    if (isLogIn) {
      threadMutate(data, {
        onSuccess: () => {
          queryClient.invalidateQueries([
            'get-infinite-information-community-threads'
          ]);
          navigate('/community/information');
        }
      });
    } else {
      navigate('/sign');
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <PrevHeaderBarWithTitleTemplate
          title="운동 가이드 글 작성"
          rightContents={
            <button className="text-[#9170F2] text-[14px]">
              {params.id ? '수정' : '등록'}하기
            </button>
          }
        >
          <CommunityWriteForms>
            <CommunityWriteForms.Categories
              registerName="category"
              options={INFORMATION_QUESTION_TYPE_LIST}
            />
            <CommunityWriteForms.Title
              registerName="title"
              placeholder="제목을 입력해주세요"
            />
            <ReactQuillEditor
              registerName="content"
              placeholder="트레이너님의 지식을 공유해 주세요"
            />
          </CommunityWriteForms>
        </PrevHeaderBarWithTitleTemplate>
      </form>
    </FormProvider>
  );
};

export default InformationCommunityWrite;

const INFORMATION_QUESTION_TYPE_LIST = [
  {
    label: '운동 방법',
    value: 'METHOD'
  },
  {
    label: '부상 / 재활',
    value: 'INJURY_REHABILITATION'
  },
  {
    label: '영양 / 식단',
    value: 'NUTRITION_DIET'
  },
  {
    label: '다이어트 / 벌크업',
    value: 'LOSE_WEIGHT_BULK_UP'
  },
  {
    label: '대회 / 바디 프로필',
    value: 'COMPETITION_BODY_PROFILE'
  }
];
